import { IFormPMAF } from '../../../../../stores/forms/FormularioPMAF.store';

export const TIPOS_INSTRUMENTO = [
  { value: 1, label: 'Lei' },
  { value: 2, label: 'Decreto' },
  { value: 3, label: 'Portaria' },
  { value: 4, label: 'Resolução' },
];

export const temErro = (formulario: Partial<IFormPMAF> | undefined | null, campo: string): boolean => {
  const possuiPolitica = formulario?.municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena;
  const possuiPlano = formulario?.possui_plano_municipal_agricultura_familiar;

  switch (campo) {
    case 'possui_politica':
      return possuiPolitica === null || possuiPolitica === undefined;
    case 'tipo_instrumento':
      return possuiPolitica === true && !formulario?.tipo_de_instrumento;
    case 'numero_publicacao':
      return possuiPolitica === true && !formulario?.numero_da_publicacao;
    case 'data_publicacao':
      return possuiPolitica === true && !formulario?.data_da_publicacao;
    case 'upload_documento':
      return possuiPolitica === true && !formulario?.upload_documento;
    case 'possui_plano':
      return possuiPlano === null || possuiPlano === undefined;
    case 'upload_plano':
      return possuiPlano === true && !formulario?.upload_plano_pmaf;
    default:
      return false;
  }
};

export const isFormValid = (formulario: Partial<IFormPMAF> | undefined | null): boolean => {
  if (formulario?.municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena === null ||
    formulario?.municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena === undefined) {
    return false;
  }
  if (formulario?.municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena === true) {
    if (
      !formulario.tipo_de_instrumento ||
      !formulario.numero_da_publicacao ||
      !formulario.data_da_publicacao ||
      !formulario.upload_documento
    ) {
      return false;
    }
  }
  if (formulario?.possui_plano_municipal_agricultura_familiar === null ||
    formulario?.possui_plano_municipal_agricultura_familiar === undefined) {
    return false;
  }
  if (formulario?.possui_plano_municipal_agricultura_familiar === true &&
    !formulario?.upload_plano_pmaf) {
    return false;
  }
  return true;
};

export const computePoliticaValue = (formulario: Partial<IFormPMAF> | undefined | null): string => {
  const possuiPolitica = formulario?.municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena;
  if (possuiPolitica === true) return 'Sim';
  if (possuiPolitica === false) return 'Não';
  return '';
};

export const computePlanoValue = (formulario: Partial<IFormPMAF> | undefined | null): string => {
  const possuiPlano = formulario?.possui_plano_municipal_agricultura_familiar;
  if (possuiPlano === true) return 'Sim';
  if (possuiPlano === false) return 'Não';
  return '';
};

export const handlePossuiPoliticaChange = (
  setPartialForm: (key: keyof IFormPMAF, value: any) => void,
  value: boolean,
) => {
  setPartialForm('municipio_possui_politica_municipal_de_agricula_familiar_ou_indigena', value);
  if (!value) {
    setPartialForm('tipo_de_instrumento', null);
    setPartialForm('numero_da_publicacao', null);
    setPartialForm('data_da_publicacao', null);
    setPartialForm('upload_documento', null);
  }
};

export const handlePossuiPlanoChange = (
  setPartialForm: (key: keyof IFormPMAF, value: any) => void,
  value: boolean,
) => {
  setPartialForm('possui_plano_municipal_agricultura_familiar', value);
  if (!value) {
    setPartialForm('upload_plano_pmaf', null);
  }
};

export const fetchFormulario = async (
  uuid: string | undefined,
  apiFn: (u: string) => Promise<any>,
  setFormulario: (f: any) => void,
  setLoading: (v: boolean) => void,
) => {
  try {
    if (!uuid) {
      throw new Error('UUID não fornecido');
    }
    const response = await apiFn(uuid);
    if (response?.dados) {
      setFormulario(response.dados);
    }
  } catch (error) {
    console.error('Erro ao carregar formulário:', error);
  } finally {
    setLoading(false);
  }
};

export const salvarRascunhoHandler = async (
  salvarRascunhoFn: () => Promise<boolean>,
  navigate: (path: string) => void,
  alertFn: (msg: string) => void,
  successRoute: string,
) => {
  try {
    const resultado = await salvarRascunhoFn();
    if (resultado) {
      alertFn('Rascunho salvo com sucesso!');
      navigate(successRoute);
    } else {
      alertFn('Erro ao salvar rascunho. Tente novamente.');
    }
    return resultado;
  } catch (error) {
    console.error('Erro ao salvar rascunho:', error);
    alertFn('Erro ao salvar rascunho. Tente novamente.');
    return false;
  }
};

export const enviarAprovacaoHandler = async (
  enviarAprovacaoFn: () => Promise<boolean>,
  isFormValidFn: () => boolean,
  navigate: (path: string) => void,
  alertFn: (msg: string) => void,
  successRoute: string,
) => {
  try {
    if (!isFormValidFn()) {
      alertFn('Preencha todos os campos obrigatórios antes de enviar para aprovação.');
      return false;
    }
    const resultado = await enviarAprovacaoFn();
    if (resultado) {
      navigate(successRoute);
    } else {
      alertFn('Erro ao enviar para aprovação. Tente novamente.');
    }
    return resultado;
  } catch (error) {
    console.error('Erro ao enviar para aprovação:', error);
    alertFn('Erro ao enviar para aprovação. Tente novamente.');
    return false;
  }
};

export default {
  temErro,
  isFormValid,
  computePoliticaValue,
  computePlanoValue,
  handlePossuiPoliticaChange,
  handlePossuiPlanoChange,
  TIPOS_INSTRUMENTO,
};
